import React, { useState, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Center,
  ColorInput,
  Text,
  Select,
} from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconVideo } from "@tabler/icons-react";
import classes from "./add.module.css";
import { RowDataGames } from "./types";

interface AddModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (newData: RowDataGames) => void;
}

const AddGameModal: React.FC<AddModalProps> = ({
  isOpen,
  onClose,
  onAdd,
}) => {
  const [newData, setNewData] = useState<RowDataGames>({
    id: "",
    name: "",
    img: "",
    show: false,
    action: "Edit", 
    createdAt: "",
    updatedAt: "",
  });
  const imageDropzoneRef = useRef<() => void>(null);

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
        setNewData({ ...newData, img: file });
    }
  };

  const handleAddData = () => {
    // Check if any required fields are empty
    if (!newData.name || !newData.img) {
      alert("Please fill in all the required fields");
      return;
    }

    onAdd(newData);

    // Clear inputs and reset state
    setNewData({
      id: "",
      name: "",
      img: "",
      show: false,
      action: "Edit",
      createdAt: "",
        updatedAt: "",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewData({
      id: "",
      name: "",
      img: "",
      show: false,
      action: "Edit",
      createdAt: "",
    updatedAt: "",
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Game
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >
      <TextInput
        label="Game name"
        placeholder="Input name"
        mb="sm"
        maxLength={255}
        value={newData.name}
        onChange={(event) =>
            setNewData({ ...newData, name: event.currentTarget.value })
        }
      />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <Dropzone
        onDrop={handleImageUpload}
        accept={["image/*"]}
        openRef={imageDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {newData.img ? (
            <img
              src={URL.createObjectURL(newData.img)}
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>


      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddData} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddGameModal;
